import { Component, inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { OtpService } from '../../services/otp.service';
import { LocaleService } from '../../services/locale.service';
import { Client } from '../../interfaces/interfaces';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './landing.component.html',
})
export class LandingComponent implements OnInit {
  client$!: Observable<Client | boolean>;
  otpService = inject(OtpService)
  localeService = inject(LocaleService);
  isBtnDisabled = false;
  ngOnInit(): void {
    this.client$ = this.otpService.getClientInfo();
    this.localeService.setLanding(this.otpService.getLocale());
  }

  onClick() {
    this.isBtnDisabled = true;
    this.otpService.getOtp();
  }
}
